<template>
  <div>
    <h4 class="site-heading my-3"><span>Quiz</span></h4>
    <div
      class="form-row align-items-end"
      v-for="(lesson_quiz, index) in quizQues"
      :key="index"
    >
      <div class="form-group col-md-11 required">
        <label class="control-label">Question</label>
        <input
          type="text"
          id="lesson_quiz.question"
          name="lesson_quiz.question"
          v-bind:class="{ 'has-error': errors.has('lesson_quiz.id') }"
          v-validate="'required'"
          v-model="lesson_quiz.question"
          class="form-control lesson_quiz.question"
          placeholder="Question"
        />
        <div class="help text-danger" v-show="errors.has('lesson_quiz.id')">
          {{ errors.first("lesson_quiz.id") }}
        </div>
      </div>
      <div class="form-group col-md-11 required">
        <label class="control-label">Question Type</label>
        <el-select
          v-model="lesson_quiz.type"
          name="lesson_quiz.type"
          placeholder="select type"
          v-validate="'required'"
          style="width: 100%"
        >
          <el-option
            v-for="item in [
              { value: 'mcq', label: 'MCQ' },
              { value: 'true_false', label: 'True/False' },
            ]"
            :key="item.value"
            v-bind:class="{ 'has-error': errors.has('lesson_quiz.type') }"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div class="help text-danger" v-show="errors.has('lesson_quiz.id')">
          {{ errors.first("lesson_quiz.id") }}
        </div>
      </div>
      <div class="form-group col-md-11 required">
        <label class="control-label">Default Mark</label>
        <input
          type="text"
          id="lesson_quiz.mark"
          name="lesson_quiz.mark"
          v-bind:class="{ 'has-error': errors.has('lesson_quiz.mark') }"
          v-validate="'required'"
          v-model="lesson_quiz.mark"
          class="form-control lesson_quiz.mark"
          placeholder="Default Mark"
        />
        <div class="help text-danger" v-show="errors.has('lesson_quiz.mark')">
          {{ errors.first("lesson_quiz.mark") }}
        </div>
      </div>

      <mcq-ques
        :quiz="lesson_quiz"
        :id="index"
        @updateMcq="updateMcq"
        v-if="lesson_quiz.type == 'mcq'"
      ></mcq-ques>
      <true-false
        v-if="lesson_quiz.type == 'true_false'"
        :id="index"
        @updateTrueFalseAns="updateTrueFalseAns"
      ></true-false>
      <div class="form-group col-md-1">
        <button
          type="button"
          class="btn btn-danger float-right"
          @click="deleteQuiz(index)"
        >
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>
    <button type="button" @click="addQuiz" class="btn btn-success">
      <i class="fa fa-plus"></i> New
    </button>
  </div>
</template>
<script>
import McqQues from "./MCQ.vue";
import TrueFalse from "./TrueFalse.vue";

export default {
  props: ["quizzes"],
  data: () => ({
    quizQues: [],
  }),
  components: {
    McqQues,
    TrueFalse,
  },
  methods: {
    addQuiz: function () {
      this.quizQues.push({
        question: "",
        type: "mcq",
      });
    },
    deleteQuiz: function (index) {
      this.quizQues.splice(index, 1);
    },
    updateMcq: function (id, val) {
      this.quizQues[id].option_1 = val.option_1;
      this.quizQues[id].option_2 = val.option_2;
      this.quizQues[id].option_3 = val.option_3;
      this.quizQues[id].option_4 = val.option_4;
      this.quizQues[id].option_5 = val.option_5;
      this.quizQues[id].correct_option = val.correct_option;
    },
    updateTrueFalseAns: function (id, ans) {
      this.quizQues[id].correct_option = ans;
    },
  },
  watch: {
    quizzes: function (val, oldVal) {
      this.quizQues = val;
    },
  },
  updated() {
    this.$emit("updateQuiz", this.quizQues);
  },
};
</script>
